import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  Tooltip,
  ListItem,
  ListItemText,
  List,
} from "@material-ui/core";
import jsPDF from "jspdf";
import InterFont from "../fonts/Inter.ttf";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { Toolbar, AppBar } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
// import rCompanyLogo from "../images/logo/ramsol_logo.jpg";
import loanSolvLogo from "../images/logo/LoanSolveLogo.png";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import Cropper from "react-easy-crop";
import axios from "axios";
import { toast } from "react-toastify";
import Notification from "../components/Notification";
import useStyles from "../themes/style";
import { useHistory, useLocation } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import "react-toastify/dist/ReactToastify.css";
import getCroppedImg from "../utils/croppedImage";
import "../css/agreement-resume.css";
import moment from "moment";
import { getMuiTheme } from "./style";
import { jwtDecode } from "jwt-decode";

const positions = [toast.POSITION.TOP_RIGHT];

const SalaryTable = ({ signData, salaryBreakupData }) => {
  const headerStyle = {
    border: "1px solid #000",
    padding: "8px",
    fontWeight: "bold",
    textAlign: "left",
  };

  const cellStyle = {
    border: "1px solid #000",
    padding: "8px",
    textAlign: "left",
  };

  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        fontFamily: "Arial, sans-serif",
        marginTop: "20px",
      }}
    >
      <thead>
        <tr>
          <th colSpan="2" style={headerStyle}>
            Name: {signData.employeeName}
          </th>
          <th colSpan="2" style={headerStyle}>
            Date: {moment(signData.offerDate).format("Do MMM YY")}
          </th>
        </tr>
        <tr>
          <th colSpan="4" style={headerStyle}>
            Designation: {signData.designation}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={headerStyle}></td>
          <td style={headerStyle}>Per month (INR)</td>
          <td style={headerStyle}>Per annum (INR)</td>
        </tr>
        <tr>
          <td style={cellStyle}>Basic</td>
          <td style={cellStyle}>{salaryBreakupData.basic}</td>
          <td style={cellStyle}>{salaryBreakupData.basic * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>HRA</td>
          <td style={cellStyle}>{salaryBreakupData.hra}</td>
          <td style={cellStyle}>{salaryBreakupData.hra * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>Other Allowance</td>
          <td style={cellStyle}>{salaryBreakupData.otherAllowance}</td>
          <td style={cellStyle}>{salaryBreakupData.otherAllowance * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>Statutory Bonus</td>
          <td style={cellStyle}>{salaryBreakupData.statutoryBonus}</td>
          <td style={cellStyle}>{salaryBreakupData.statutoryBonus * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>Shift Allowance</td>
          <td style={cellStyle}>{salaryBreakupData.shiftAllowance}</td>
          <td style={cellStyle}>{salaryBreakupData.shiftAllowance * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>Total Gross Salary (A)</td>
          <td style={headerStyle}>{salaryBreakupData.totalGrossSalary}</td>
          <td style={headerStyle}>{salaryBreakupData.totalGrossSalary * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
        </tr>
        <tr>
          <td style={cellStyle}>Add: Employer PF @ 12% on basic</td>
          <td style={cellStyle}>{salaryBreakupData.addEmployerPF}</td>
          <td style={cellStyle}>{salaryBreakupData.addEmployerPF * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>Total CTC (B)</td>
          <td style={headerStyle}>{salaryBreakupData.totatCTC}</td>
          <td style={headerStyle}>{salaryBreakupData.totatCTC * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
        </tr>
        <tr>
          <td style={headerStyle}>Deductions</td>
          <td style={cellStyle}></td>
          <td style={cellStyle}></td>
        </tr>
        <tr>
          <td style={cellStyle}>Employee PF @ 12% on basic</td>
          <td style={cellStyle}>{salaryBreakupData.employeePF}</td>
          <td style={cellStyle}> {salaryBreakupData.employeePF * 12}</td>
        </tr>
        <tr>
          <td style={cellStyle}>Professional Tax</td>
          <td style={cellStyle}>{salaryBreakupData.professionalTax}</td>
          <td style={cellStyle}>{salaryBreakupData.professionalTax * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>Total Deductions (C)</td>
          <td style={headerStyle}>{salaryBreakupData.totalDeductions}</td>
          <td style={headerStyle}>{salaryBreakupData.totalDeductions * 12}</td>
        </tr>
        <tr>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
          <td style={headerStyle}>
            <br />
          </td>
        </tr>
        <tr>
          <td style={headerStyle}>NET SALARY (A-C)</td>
          <td style={headerStyle}>
            {salaryBreakupData.totalGrossSalary -
              salaryBreakupData.totalDeductions}
          </td>
          <td style={headerStyle}>
            {salaryBreakupData.totalGrossSalary * 12 -
              salaryBreakupData.totalDeductions * 12}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

function OfferDetailsChooseTemplate() {
  const token = localStorage.getItem("token");
    const decode = jwtDecode(token);
  const history = useHistory();
  const location = useLocation();
  const candidateId = new URLSearchParams(location.search).get("id");
  const agreementfileRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [hideActionBtns, setHideActionBtns] = useState(false);
  const [signData, setSignData] = useState({
    employeeName: "Sample Name",
    companyName: "Sample Name",
    designation: "XXXXXXXXX",
    offerDate: new Date("01-01-1900"),
    probationPeriod: 0,
    address: "XX, XXXXXX",
    apartment: "XXXXXXXXXX",
    city: "XXXXXXX",
    postalCode: "XXXXXX",
    state: "XXXXXXXXX",
  });
  const [salaryBreakupData, setSalaryBreakupData] = useState({
    basic: 0,
    hra: 0,
    otherAllowance: 0,
    statutoryBonus: 0,
    shiftAllowance: 0,
    addEmployerPF: 0,
    addESI: 0,
    gratuity: 0,
    employeeESI: 0,
    employeePF: 0,
    professionalTax: 0,
    totalDeductions: 0,
    totatCTC: 0,
    totalGrossSalary: 0,
  });
  const [offerDetailsModal, setOfferDetailsModal] = useState(false);

  useEffect(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = () => {
    setModalOpen(false);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const validationSchema = Yup.object().shape({
    employeeName: Yup.string()
      .max(255)
      .required("Employee Name is required")
      .max(255)
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Name Must be Alphanumeric",
      }),
    companyName: Yup.string().required("Company Name is required"),
    designation: Yup.string().required("Designation is required"),
    offerDate: Yup.string().required("Offer Date is required"),
    probationPeriod: Yup.number().required(
      "Probation Period field is required",
    ),
    basic: Yup.number()
      .min(0, "Basic pay must be a number")
      .required("Basic pay is required"),
    otherAllowance: Yup.number()
      .min(0, "Other Allowance must be a number")
      .required("Other Allowance is required"),
    shiftAllowance: Yup.number()
      .min(0, "Shift Allowance must be a number")
      .required("Shift Allowance is required"),
    professionalTax: Yup.number()
      .min(0, "Professional Tax must be a number")
      .required("Professional Tax is required"),
    address: Yup.string().required("Address is required"),
    apartment: Yup.string().nullable().notRequired(),
    city: Yup.string().required("City name is required"),
    postalCode: Yup.string().required("ZIP/postal code is required"),
    state: Yup.string().required("State/province is required"),
  });


  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);

  const theme = useTheme();
  const classes = useStyles();
  const isMatch = useMediaQuery(theme.breakpoints.down("sm"));

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;
    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const styles = {
    grandMasterContainer: {
      minWidth: "800px",
      minHeight: "1000px",
      margin: "auto",
      maxWidth: "800px",
    },
    masterContainer: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "40px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerTwo: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "60px auto",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
      // filter: "blur(0px)",
    },
    masterContainerThree: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "120px auto 0px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
    masterContainerFour: {
      minWidth: "802px",
      minHeight: "1115px",
      maxWidth: "800px",
      margin: "100px auto 0px",
      padding: "16px",
      border: "1px solid #eee",
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "'Inter', sansSerif",
      color: "#555",
      backgroundColor: "#F9FAFC",
    },
  };

  const [loader, setLoader] = useState(false);

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImgae, setCroppedImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleSelectCandidateType = (role) => {
    if (role === "REGULAR") {
      window.location.href = `${process.env.REACT_APP_DOMAIN}/offer-details?id=${candidateId}`;
    }
    if (role === "CONTRACT") {
      window.location.href = `${process.env.REACT_APP_DOMAIN}/offer-details-contract?id=${candidateId}`;
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file && file?.size >= 2000000) {
        handleNotificationCall("info", "Maximum File Size Limit 2mb");
        return;
      }
      const reader = new FileReader();
      reader.addEventListener("load", () => setImageSrc(reader.result));
      reader.readAsDataURL(file);
      setShowModal(true);
    }
  };

  const onCropComplete = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedAreaPixels(croppedAreaPixels);
      const reader = new FileReader();
      reader.readAsDataURL(croppedImageBlob);
      reader.onloadend = () => {
        setCroppedImage(reader.result); // This will be a base64 data URL
      };
    },
    [imageSrc],
  );

  const handleUpload = async () => {
    if (!croppedAreaPixels || !imageSrc) return;
    const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

    if (croppedImageBlob.size > 3 * 1024 * 1024) {
      alert("The cropped image size exceeds 3MB. Please crop again.");
      return;
    }
    setShowModal(false);
  };

  const handleGeneratePdf = async () => {
    setHideActionBtns(true);
    // if (!croppedImgae) {
    //   handleNotificationCall("info", " please Attach your Signature");
    //   setHideActionBtns(false);
    //   return;
    // }
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
      lineHeight: 1.2,
    });

    doc.addFont(InterFont, "Inter", "normal");
    doc.setFont("Inter");
    const element = agreementfileRef.current;
    if (element) {
      await doc.html(element, {
        callback: (doc) => {
          const pdfBlob = doc.output("blob");
          // handleAgreementSign(pdfBlob, doc);
          doc.save(`non-disclosure_agreement${Date.now()}.pdf`);
        },
        x: 10,
        y: 10,
        html2canvas: {
          scale: 0.7, // Adjust the scale for better quality
          logging: true, // Enable logging for debugging
          useCORS: true,
          letterRendering: false,
        },
        windowWidth: 800,
      });
    }
  };

  const handleClearFormData = () => {
    setImageSrc(null);
    setCroppedImage(null);
    handleModalOpen();
  };

  return (
    <div className={classes.backgroundColor}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <>
          <AppBar className={classes.appBarBg}>
            <Toolbar className={classes.toolbarLP}>
              {isMatch ? (
                <>
                  <div className={classes.refoTitleMobile}>
                    <p className="refo-name">refo</p>
                  </div>
                  <div className={classes.flexCenter} style={{ width: "100%" }}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </div>
                  {/* <DrawerComp /> */}
                </>
              ) : (
                <Grid className={classes.gridCenter} container spacing={2}>
                  <Grid item xs={1} md={1} className={classes.refoTitle}>
                    <p className="refo-name">refo</p>
                  </Grid>
                  <Grid item xs={11} md={11} className={classes.flexCenter}>
                    <div className="refo-full-name">
                      <h1>
                        refo<span>recruiter essentials & faster outcomes</span>
                      </h1>
                    </div>
                  </Grid>
                </Grid>
              )}
            </Toolbar>
          </AppBar>

          <div style={{ marginTop: "5rem", overflow: "auto",filter:"blur(1px)" }}>
            <div ref={agreementfileRef} style={styles.grandMasterContainer}>
              <div style={styles.masterContainer}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <img
                          src={loanSolvLogo}
                          width="300"
                          alt="logo_company"
                          style={{ display: "block", margin: " 0 auto" }}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "end",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "10px 0",
                        }}
                      >
                        <p>
                          Date: {moment(signData.offerDate).format("Do MMMM YYYY")}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p style={{ margin: "8px 0px" }}>
                          Mr/Ms. {signData.employeeName}
                        </p>
                        <p style={{ margin: "8px 0px" }}>{signData.address},</p>
                        <p style={{ margin: "8px 0px" }}>
                          {signData.apartment},
                        </p>
                        <p style={{ margin: "8px 0px" }}>
                          {signData.city} - {signData.postalCode},
                        </p>
                        <p style={{ margin: "8px 0px" }}>{signData.state}.</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p>Dear {signData.employeeName},</p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                        }}
                      >
                        <p>
                          With reference to the discussions had with you, we are
                          pleased to offer you the position of{" "}
                          <b>{signData.designation}</b> in our organization.
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ul
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStyle: "disc",
                            }}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              Your date of joining is today,{" "}
                              {moment(signData.offerDate).format("Do MMMM YY")}
                              <br />
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You will be paid an Annual CTC of Rs.
                              {salaryBreakupData.totalGrossSalary -
                                salaryBreakupData.totalDeductions}
                              -as per the breakup attached.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You will be on probation for a period{" "}
                              {signData.probationPeriod} months and your
                              services will be confirmed on successful
                              completion of the probation period.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              It is an express condition that you shall not,
                              without express permission, undertake or be
                              connected to any other business, part time or
                              other work or public office on payment or
                              otherwise on your own or on behalf of anyone else.
                              In the event of breach of this condition you will
                              be liable for termination of your services with
                              immediate effect.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              You may resign from the service of the Company
                              only after having served the notice period of
                              three months (or) salary in lieu of notice period.
                              Notice period would become effective from the date
                              of receipt of the letter of resignation. During
                              the notice period, you will not be entitled to any
                              additional benefits apart from your fixed salary,
                              viz, leave, incentives, etc., unless expressly
                              sanctioned in advance and in writing. The company
                              at its sole discretion may choose to relieve you
                              any time during the course of notice period.
                            </li>
                          </ul>
                          <p style={{ height: "56px" }}></p>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={styles.masterContainerTwo}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <img
                          src={loanSolvLogo}
                          width="300"
                          alt="logo_company"
                          style={{ display: "block", margin: " 0 auto" }}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p>
                          <ul
                            style={{
                              marginTop: "0",
                              paddingLeft: "20px",
                              listStyle: "disc",
                            }}
                          >
                            <li style={{ paddingLeft: "16px" }}>
                              The company reserves the right to terminate your
                              services at any time without assigning any reason
                              whatsoever.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              By way of signing duplicate copy of this letter,
                              you undertake to abide by the codes of
                              Confidentiality Agreement & Code of Conduct of the
                              Company. In the event of a breach on your part,
                              you will be liable for termination of your
                              services with immediate effect.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              Your appointment is on the basis of the
                              representation made or facts disclosed in your
                              application for appointment. In case of any fact
                              or representation is found to be wrong or
                              considered to be concealed, it shall invalidate
                              the appointment and shall deem to be automatically
                              cancelled.
                            </li>
                            <li style={{ paddingLeft: "16px" }}>
                              Terms of this offer are strictly confidential
                              between you and the company and any breach of this
                              confidence will be viewed with utmost seriousness.
                            </li>
                          </ul>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "left",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          margin: "0",
                        }}
                      >
                        <p style={{ margin: "8px 0px" }}>Best Wishes,</p>
                        <p style={{ margin: "8px 0px" }}>Yours sincerely,</p>
                        <p style={{ margin: "8px 0px" }}>
                          For {signData.companyName}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                        }}
                      >
                        <p style={{ margin: "20px 0 0" }}>
                          <b>Authorized Person Name</b> &nbsp;{" "}
                          {"Balaji Ramaswamy,"}{" "}
                        </p>
                        <p style={{ margin: "0 0 60px" }}>
                          <b>Designation</b> &nbsp; {"Director"}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p
                          style={{
                            textAlign: "left",
                            color: "#1A1C21",
                          }}
                        >
                          I accept.
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.5",
                          margin: "0",
                          fontSize: "11pt",
                          position: "relative",
                        }}
                      >
                        <table
                          style={{
                            tableLayout: "fixed",
                            width: "35%",
                            textAlign: "left",
                          }}
                        >
                          <tbody>
                            <tr>
                              <th
                                style={{
                                  textAlign: "left",
                                  color: "#1A1C21",
                                }}
                              >
                                Signature
                              </th>
                              <td>
                                <span
                                  style={{
                                    width: "200px",
                                    display: "block",
                                    borderBottom: "1px solid #000",
                                    marginLeft: "10px",
                                    padding: "5px 10px",
                                  }}
                                >
                                  <img
                                    src={croppedImgae}
                                    style={{
                                      position: "absolute",
                                      top: "-20px",
                                      left: "240px",
                                      maxWidth: "160px",
                                      height: "45px",
                                      objectFit: "contain",
                                    }}
                                    alt="add_signature_here"
                                  />
                                  {!hideActionBtns && (
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        position: "absolute",
                                        top: "-5px",
                                        left: "450px",
                                      }}
                                    >
                                      <Tooltip
                                        title="Remove sign"
                                        placement="bottom"
                                        aria-label="delete"
                                      >
                                        <DeleteIcon
                                          className={classes.toolIconDelete}
                                          onClick={(e) => {
                                            setCroppedImage(null);
                                          }}
                                        />
                                      </Tooltip>
                                      <Tooltip
                                        title="Edit Details"
                                        placement="bottom"
                                        aria-label="delete"
                                      >
                                        <EditIcon
                                          className={classes.toolIcon}
                                          onClick={() => handleModalOpen()}
                                          // onClick={() => document.getElementById("editFileInput")?.click()}
                                        />
                                      </Tooltip>
                                    </div>
                                  )}
                                </span>
                              </td>
                            </tr>
                            <tr style={{ paddingTop: "12px" }}>
                              <th
                                style={{
                                  textAlign: "left",
                                  color: "#1A1C21",
                                }}
                              >
                                Name
                              </th>
                              <td>
                                <span
                                  style={{
                                    width: "200px",
                                    display: "block",
                                    borderBottom: "1px solid #000",
                                    marginLeft: "10px",
                                    padding: "5px 10px",
                                  }}
                                ></span>
                              </td>
                            </tr>
                            <tr>
                              <th
                                style={{
                                  textAlign: "left",
                                  color: "#1A1C21",
                                }}
                              >
                                Date
                              </th>
                              <td>
                                <span
                                  style={{
                                    width: "200px",
                                    display: "block",
                                    borderBottom: "1px solid #000",
                                    marginLeft: "10px",
                                    padding: "5px 10px",
                                  }}
                                >
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={styles.masterContainerFour}>
                <table
                  style={{
                    fontSize: "12px",
                    lineHeight: "20px",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center", margin: "0" }}>
                        <img
                          src={loanSolvLogo}
                          width="300"
                          alt="logo_company"
                          style={{ display: "block", margin: " 0 auto" }}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "12pt" }}>
                    <tr>
                      <td
                        style={{
                          textAlign: "justify",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <SalaryTable
                          signData={signData}
                          salaryBreakupData={salaryBreakupData}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          textAlign: "center",
                          color: "#000",
                          fontWeight: "500",
                          padding: "0 10px",
                          lineHeight: "1.7",
                          margin: "0",
                        }}
                      >
                        <p style={{ padding: "0px 15px " }}>
                          <b>
                            $$ Group Mediclaim for the employee will be provided
                            for 2 lakhs coverage Income Tax will be applicable
                            as per IT Act
                          </b>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                margin: "0px 20px 20px 20px",
              }}
            >
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleClearFormData}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                size="small"
                color="primary"
                className={classes.green}
                onClick={handleGeneratePdf}
              >
                Send
              </Button>
            </div>
          </div>

          <Dialog
            aria-labelledby="dialog-title"
            open={modalOpen}
            width="xs"
            maxWidth="xs"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <h2
              style={{
                fontSize: "1.2rem",
                fontWeight: 500,
                padding: "10px 20px",
                margin: "0px",
              }}
            >
              Candidate Type
            </h2>
            <List
              style={{
                padding: "0px 10px 10px 10px",
                marginBottom: "10px  ",
              }}
            >
              <ListItem
                autoFocus
                button
                onClick={() => handleSelectCandidateType("REGULAR")}
              >
                <ListItemText primary="Regular Candidate" />
              </ListItem>
              <ListItem
                button
                onClick={() => handleSelectCandidateType("CONTRACT")}
              >
                <ListItemText primary="Contract Candidate" />
              </ListItem>
            </List>
          </Dialog>

          <Dialog
            aria-labelledby="dialog-title"
            open={showModal}
            width="md"
            maxWidth="sm"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
            onClose={() => setShowModal(false)}
          >
            <DialogContent>
              <div
                className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
              >
                <Typography variant="subtitle2" className={classes.inputRoot}>
                  {" "}
                  Crop Image{" "}
                </Typography>

                <div className={classes.pdfModalCloseBtn}>
                  <CloseIcon className={classes.closeBtn} />
                </div>
              </div>
              <div
                className="d-flex"
                style={{ position: "sticky", minHeight: "50vh" }}
              >
                {imageSrc && (
                  <div className="crop-container">
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={16 / 9}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                )}
              </div>
              <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    setShowModal(false);
                    setCroppedImage(null);
                    setImageSrc(null);
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={handleUpload}
                >
                  Crop
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <ToastContainer
            closeButton={
              <CloseButton className={classes.notificationCloseButton} />
            }
            closeOnClick={false}
            hideProgressBar={true}
          />
          <Backdrop className={classes.backdrop} open={loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      </MuiThemeProvider>
    </div>
  );
}

export default OfferDetailsChooseTemplate;
function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
